
import DatetimePicker from './DatetimePicker'

const install = Vue => {
  Vue.component('wwi-datetime-picker', DatetimePicker)
}

export default install